import { MatSnackBar } from '@angular/material/snack-bar'
import { AppContext } from '../app-context.js'
import { Title } from '@angular/platform-browser'
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component.js'
import { ScreenUtil } from '@lg/shared/for-apps'
import { ClientLogLevel } from '@lg/shared/for-apps'
import { signal } from '@angular/core'

export class FrontendAppBridge {
	private static spinnerTextSignal = signal<string | undefined>(undefined)

	static get isSpinnerVisible() {
		return this.spinnerTextSignal() != undefined
	}
	static set isSpinnerVisible(value: boolean) {
		if (!value) {
			this.spinnerTextSignal.set(undefined)
		} else if (!this.spinnerTextSignal()) {
			this.spinnerTextSignal.set('Loading...')
		}
	}

	static set spinnerText(text: string | undefined) {
		this.spinnerTextSignal.set(text)
	}

	static get spinnerText() {
		return this.spinnerTextSignal()
	}

	static set title(title: string) {
		this.setTitle(title)
	}

	static get title() {
		return this.getTitle()
	}

	static setTitle(title: string) {
		AppContext.resolve(Title).setTitle(title)
	}

	static getTitle() {
		return AppContext.resolve(Title).getTitle()
	}

	static showNotification(
		type: ClientLogLevel,
		message: string,
		autoClose?: boolean | number,
		tooltip = '',
	) {
		const snackBar = AppContext.injector.get(MatSnackBar)
		if (autoClose === undefined) {
			autoClose = type != 'error' && type != 'warning'
		}
		if (typeof autoClose == 'boolean') {
			autoClose = autoClose ? 2000 : undefined
		}

		const snackBarRef = snackBar.openFromComponent(SnackBarComponent, {
			data: {
				message,
				type,
				tooltip,
				duration: autoClose,
				dismiss: () => snackBarRef.dismiss(),
			},
			duration: autoClose,
			panelClass: `${type}-snackbar`,
		})
	}

	static showError(error: any, autoClose?: boolean | number) {
		this.showNotification('error', error?.message || error, autoClose)
		console.error(error)
	}

	static showSuccess(message: string, autoClose?: boolean | number) {
		this.showNotification('success', message, autoClose)
	}

	static showWarning(message: string, autoClose?: boolean | number) {
		this.showNotification('warning', message, autoClose)
	}

	static showInfo(message: string, autoClose?: boolean | number) {
		this.showNotification('info', message, autoClose)
	}

	static provideDownload(content: any, fileName: string, mimeType?: string) {
		ScreenUtil.provideDownload(content, fileName, 'download', mimeType)
	}

	static openDownloadInNewWindow(
		content: any,
		fileName: string,
		mimeType?: string,
	) {
		ScreenUtil.provideDownload(content, fileName, 'open', mimeType)
	}
}
